import ArrowBackRoundedIcon from "@mui/icons-material/ArrowBackRounded";
import {
  Box,
  Button,
  CircularProgress,
  Grid,
  IconButton,
  Stack,
  Typography,
} from "@mui/material";
import Tooltip from "@mui/material/Tooltip";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { default as utilities, default as utils } from "../../../../src/utility/utilities";
import { useAccess } from "../../../AccessContext";
import AssetRepository from "../../../api/repositories/assetRepository";
import "../../../assets/css/finalreporttable.css";
import "../../../assets/css/reports.css";
import reportslogo from "../../../assets/images/reportslogo.png";
import { DefaultCard } from "../../../assets/styled-components/card";
import PageLoader from "../../../components/commoncomponents/PageLoader";
import { updateAssetDetails } from "../../../redux/actions/assetActions";
import { getAuthToken, getcompanyId, getuserId } from '../../../utility/tokenUtility';
import AssetFinalreport from "../../commoncomponents/AssetFinalreport";
import CustomAgGrid from "../../commoncomponents/CustomAgGrid";
import CustomSelectInput from "../../commoncomponents/CustomSelectInput";
import PageTitle from "../../commoncomponents/PageTitle";
import RefreshAssetButtons from "../../commoncomponents/RefreshAssetButtons";
import { set } from "react-hook-form";
import { ErrorChips, SuccessChips, WarningChips } from "../../../assets/styled-components/chips";
const AssetAnalysisreport = () => {
  const token = getAuthToken("id_token");
  const companyId = getcompanyId('companyId');
  const userId = getuserId('UserId');
  const [data, setData] = useState([]);
  const [tableValues, setTableValues] = useState(null);
  const [commonTableLabel, setcommonTableLabel] = useState(null);
  const [leveldata, setLeveldata] = useState([]);
  const [history, setHistory] = useState([]);
  const [historyApiFilterData, setHistoryApiFilterData] = useState([]);
  const [canGoBack, setCanGoBack] = useState(false);
  const gridRef = useRef(null);
  const [lastApiParams, setLastApiParams] = useState(null); // Add this state to store last API call parameters
  const dispatch = useDispatch();
  const [level, setLevel] = useState(1);
  const [AssetOrderStatus, setAssetOrderStatus] = useState("");
  const [secondLevelRes, setSecondLevelRes] = useState({});
  const [typeCodeIdClick, setTypeCodeIdClick] = useState(null);
  const [locationIdClick, setLocationIdClick] = useState(null);
  const [groupByValue, setGroupByValue] = useState();

  // Move filterDetails state declaration before filterDetailsData
  let assetDetails = useSelector((state) => state.assetAnalysisFilterDetails);

  const accessData = useAccess();
  const access = utilities.getScreenPermissions(accessData, "ENGA001");

  const [assetDetailsData, setAssetDetailsData] = useState(assetDetails);
  const roleName = "UserDept"; // Define the local storage key

  const [assetServiceValue, setAssetServiceValue] = useState();

  const handleOnChange = async (name, value) => {
    let updatedAssetDetails = { ...assetDetailsData, [name]: value?.label || "" };
    if (value && value.id) {
      switch (name) {
        case "hospital":
          updatedAssetDetails["hospitalId"] = value.id;
          updatedAssetDetails["hospital"] = value.label;
          break;
        case "AssetStatus":
          updatedAssetDetails["assetStatusId"] = value.id;
          break;
        case "groupBy":
          updatedAssetDetails["groupById"] = value.id;
          break;
        case "AssetType":
          updatedAssetDetails["assetTypecodeid"] = "";
          break;
        case "Level":
          updatedAssetDetails["Level"] = value?.label;
          if (value?.label == 'HQ') {

            updatedAssetDetails["assetStatusId"] = "";
            updatedAssetDetails["hospitalId"] = "";
          }
          break;
        default:
          break;
      }
    }
    setAssetDetailsData(updatedAssetDetails);

    dispatch(updateAssetDetails(updatedAssetDetails));

    setErrors((prevErrors) => ({ ...prevErrors, [name]: "" }));
  };

  const hiddenFields = ["typeCodeId", "locationCodeId", "assetId", "realTimestatusId"];
  const columnsForSummary = assetServiceValue?.label === "All" ? [
    { field: "facilityName", filter: 'agTextColumnFilter', headerName: "Hospital", width: 180 },
    { field: "level", filter: 'agTextColumnFilter', headerName: "Level", width: 180 },
    { field: "option", filter: 'agTextColumnFilter', headerName: "Option", width: 180 },
    { field: "femsAssetCount", filter: 'agNumberColumnFilter', headerName: "Total Asset FEMS", width: 180, cellStyle: { textAlign: "right" } },
    { field: "bemsAssetCount", filter: 'agNumberColumnFilter', headerName: "Total Asset BEMS", width: 180, cellStyle: { textAlign: "right" } },
    { field: "totalCount", filter: 'agNumberColumnFilter', headerName: "Total Assets", width: 180, cellStyle: { textAlign: "right" } },
  ] : assetServiceValue?.label === "FEMS" ? [
    { field: "facilityName", filter: 'agTextColumnFilter', headerName: "Hospital", width: 180 },
    {
      field: "level",
      headerName: "Level",
      width: 180,
      valueGetter: () => levellist?.label, // Always return 'hq' for the level column
      filter: 'agTextColumnFilter',
    },
    {
      field: "option",
      valueGetter: () => optionslist?.label, // Always return 'hq' for the level column
      headerName: "Option",
      width: 180,
      filter: 'agTextColumnFilter',
    },
    { field: "assetCount", filter: 'agNumberColumnFilter', headerName: "Total Asset FEMS", width: 180 },

    // Uncomment and add filters if needed
    // { field: "bemsAssetCount", filter: 'agNumberColumnFilter', headerName: "Total Asset BEMS", width: 180 },
    // { field: "totalCount", filter: 'agNumberColumnFilter', headerName: "Total Assets", width: 180 },
  ] : [
    { field: "facilityName", filter: 'agTextColumnFilter', headerName: "Hospital", width: 180 },
    {
      field: "level",
      valueGetter: () => levellist?.label,
      filter: 'agTextColumnFilter',
      headerName: "Level",
      width: 180,
    },
    {
      field: "option",
      valueGetter: () => optionslist?.label,
      filter: 'agTextColumnFilter',
      headerName: "Option",
      width: 180,
    },
    { field: "assetCount", filter: 'agNumberColumnFilter', headerName: "Total Asset BEMS", width: 180 },

    // Uncomment and add filters if needed
    // { field: "femsAssetCount", filter: 'agNumberColumnFilter', headerName: "Total Asset FEMS", width: 180 },
    // { field: "totalCount", filter: 'agNumberColumnFilter', headerName: "Total Assets", width: 180 },
  ];

  // const columns =
  //   data?.length > 0
  //     ? [
  //       ...Object.keys(data[0])
  //         .filter((key) => key !== "no")
  //         .map((key) => {
  //           function formatHeaderName(key) {
  //             return key
  //               .replace(/([A-Z])/g, ' $1')
  //               .replace(/^./, str => str.toUpperCase())
  //               .trim();
  //           }
  //           if (typeof data[0][key] === "object" && data[0][key] !== null) {
  //             return {
  //               headerName: key,
  //               children: Object.keys(data[0][key]).map((subKey) => ({
  //                 field: `${key}.${subKey}`,
  //                 headerName: subKey,
  //                 sortable: false,
  //                 // filter: false,
  //                 flex: 1,
  //                 wrapHeaderText: true, // Enable text wrapping for the header
  //               })),
  //               headerClass: "center-align",
  //               cellClass: "wrap-text",
  //             };

  //           } else {
  //             return {
  //               field: key,
  //               headerName: formatHeaderName(key),
  //               sortable: false,
  //               // filter: false,
  //               wrapHeaderText: true,
  //               headerClass: "center-align",
  //               cellClass: "wrap-text",
  //               flex: 1,
  //               hide: hiddenFields.includes(key), // Hide if key is in the hiddenFields array
  //               cellRenderer: (params) => {
  //                 if (
  //                   (key === "assetNo" && level === 2) ||
  //                   (level === 1 && typeof params.value === "number" && params.value >= 0 && (key == "count" || key == "assetCount")) ||
  //                   (key === "assetNo" && groupByValue?.id == 11 && level == 1)
  //                 ) {
  //                   return (
  //                     <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
  //                       {params.value === 0 ? (
  //                         <span
  //                           style={{
  //                             color: "gray", // Optional: make the text look disabled
  //                             textDecoration: "none",
  //                             // cursor: "not-allowed",
  //                             textAlign: "center",
  //                           }}
  //                         >
  //                           {params.value}
  //                         </span>
  //                       ) : (
  //                         <a
  //                           href="#"
  //                           style={{
  //                             color: "blue",
  //                             textDecoration: "underline",
  //                             cursor: "pointer",
  //                             textAlign: "center",
  //                           }}
  //                           onClick={(event) => {
  //                             event.preventDefault();
  //                             handleNameClick(key, params.data);
  //                             setTypeCodeIdClick(params.data.typeCodeId);
  //                             setLocationIdClick(params.data.locationCodeId);
  //                           }}
  //                         >
  //                           {params.value}
  //                         </a>
  //                       )}
  //                     </div>
  //                   );
  //                 }
  //                 return params.value;
  //               },
  //             };
  //           }
  //         }),
  //     ]
  //     : [];


  const columns =
    Array.isArray(data) && data.length > 0
      ? [
        ...Object.keys(data[0])
          .filter((key) => key !== "no")
          .map((key) => {
            // =====================================================
            // Format Header Name
            // =====================================================
            const formatHeaderName = (key) => {
              return key
                .replace(/([A-Z])/g, " $1")
                .replace(/^./, (str) => str.toUpperCase())
                .trim();
            };

            // =====================================================
            // Render Risk Level Chip
            // =====================================================
            const renderRiskChip = (value) => {
              const v = String(value ?? "")
                .trim()
                .toLowerCase();

              if (v === "moderate risk") {
                return <WarningChips label={value} />;
              }

              if (v === "low risk") {
                return <SuccessChips label={value} />;
              }

              if (v === "high risk") {
                return <ErrorChips label={value} />;
              }

              return value ?? "";
            };

            // =====================================================
            // Get First Row Value
            // =====================================================
            const firstRowValue = data[0]?.[key];

            // =====================================================
            // Check Number Column
            //
            // Handles:
            // 0
            // 1
            // 338
            // "0"
            // "1"
            // "338"
            // =====================================================
            const isNumberColumn = data.some((row) => {
              const value = row?.[key];

              if (
                value === null ||
                value === undefined ||
                value === ""
              ) {
                return false;
              }

              return !isNaN(Number(value));
            });

            // =====================================================
            // Purchase Order Number
            //
            // purchaseOrderNo may be returned as a string,
            // therefore explicitly make it a right-aligned column.
            // =====================================================
            const isPurchaseOrderColumn =
              key.toLowerCase() === "purchaseorderno";

            // =====================================================
            // Asset Risk Level Column
            // =====================================================
            const isRiskColumn =
              key.toLowerCase() === "assetrisklevel";

            // =====================================================
            // Nested Object Column
            // =====================================================
            if (
              firstRowValue !== null &&
              firstRowValue !== undefined &&
              typeof firstRowValue === "object" &&
              !Array.isArray(firstRowValue)
            ) {
              return {
                headerName: formatHeaderName(key),

                children: Object.keys(firstRowValue).map(
                  (subKey) => ({
                    field: `${key}.${subKey}`,
                    headerName: formatHeaderName(subKey),
                    sortable: false,
                    flex: 1,
                    wrapHeaderText: true,
                    headerClass: "center-align",
                    cellClass: "wrap-text",
                  })
                ),

                headerClass: "center-align",
              };
            }

            // =====================================================
            // Normal Column
            // =====================================================
            return {
              field: key,

              headerName: formatHeaderName(key),

              sortable: false,

              wrapHeaderText: true,

              headerClass: "center-align",

              flex: 1,

              hide: hiddenFields?.includes(key) ?? false,

              // ===================================================
              // Cell Style
              //
              // Number columns       -> Right
              // purchaseOrderNo      -> Right
              // Risk column          -> Center
              // Text columns         -> Left
              // ===================================================
              cellStyle: (params) => {
                if (isRiskColumn) {
                  return {
                    textAlign: "center",
                  };
                }

                if (
                  isNumberColumn ||
                  isPurchaseOrderColumn
                ) {
                  return {
                    textAlign: "right",
                  };
                }

                return {
                  textAlign: "left",
                };
              },

              // ===================================================
              // Cell Class
              // ===================================================
              cellClass: (params) => {
                if (isRiskColumn) {
                  return "wrap-text";
                }

                if (
                  isNumberColumn ||
                  isPurchaseOrderColumn
                ) {
                  return "wrap-text ag-right-aligned-cell";
                }

                return "wrap-text";
              },

              // ===================================================
              // Cell Renderer
              // ===================================================
              cellRenderer: (params) => {
                // =================================================
                // 1. Asset Risk Level
                // =================================================
                if (
                  key.toLowerCase() === "assetrisklevel"
                ) {
                  return renderRiskChip(params.value);
                }

                // =================================================
                // 2. Clickable Asset / Count / Asset Count
                // =================================================
                if (
                  // Asset No for Level 2
                  (key === "assetNo" && level === 2) ||

                  // Count / Asset Count for Level 1
                  (
                    level === 1 &&
                    params.value !== null &&
                    params.value !== undefined &&
                    params.value !== "" &&
                    !isNaN(Number(params.value)) &&
                    Number(params.value) >= 0 &&
                    (
                      key === "count" ||
                      key === "assetCount"
                    )
                  ) ||

                  // Asset No for Group By
                  (
                    key === "assetNo" &&
                    groupByValue?.id === 11 &&
                    level === 1
                  )
                ) {
                  return (
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "flex-end",
                        alignItems: "center",
                        width: "100%",
                      }}
                    >
                      {Number(params.value) === 0 ? (
                        <span
                          style={{
                            color: "gray",
                            textDecoration: "none",
                            textAlign: "right",
                          }}
                        >
                          {params.value}
                        </span>
                      ) : (
                        <a
                          href="#"
                          style={{
                            textDecoration: "underline",
                            cursor: "pointer",
                          }}
                          onClick={(event) => {
                            event.preventDefault();

                            handleNameClick(
                              key,
                              params.data
                            );

                            setTypeCodeIdClick(
                              params.data?.typeCodeId
                            );

                            setLocationIdClick(
                              params.data?.locationCodeId
                            );
                          }}
                        >
                          {params.value}
                        </a>
                      )}
                    </div>
                  );
                }

                // =================================================
                // 3. Default Value
                // =================================================
                return params.value ?? "";
              },
            };
          }),
      ]
      : [];

  const [serviceTypeOptions, setServiceTypeOptions] = useState([
    { label: "All", value: "All" },
    { label: "BEMS", value: "BEMS" },
    { label: "FEMS", value: "FEMS" },
  ]);
  const [statusTypeOption, setStatusTypeOption] = useState([
    { label: "All", value: "All" },
    { label: "Active", value: "Active" },
    { label: "InActive", value: "InActive" },
  ]);
  const [riskTypeOption, setRiskTypeOption] = useState([
    { label: "All", value: "All" },
    { label: "High", value: "High" },
    { label: "Low", value: "Low" },
    { label: "Moderate", value: "Moderate" },
  ]);

  const levelname = [
    { label: "Hospital", value: "Hospital" },
    { label: "HQ", value: "HQ" },
  ];

  const optionsname = [
    { label: "Summary", value: "Summary" },
    { label: "Details", value: "Details" },
  ];
  const [optionslist, setOptionsList] = useState();
  const [levellist, setLevelList] = useState({ label: '' });

  const [hospitalOptions, setHospitalOptions] = useState();
  const [hospitalValue, setHospitalValue] = useState();

  const [workGroupOptions, setWorkGroupOptions] = useState();
  const [workGroupOptionsForDetails, setWorkGroupOptionsForDetails] = useState();

  const [AssetStatusOptions, setAssetStatusOptions] = useState();
  const [AssetStatusOptionsForDetails, setAssetStatusOptionsForDetails] = useState();
  const [loadingPage, setLoadingPage] = useState(false)
  const [loading, setLoading] = useState(false)

  const [assetTypeOptions, setassetTypeOptions] = useState();
  const [allRows, setAllRows] = useState([]);
  const [assetStatusValue, setAssetStatusValue] = useState();
  const [disableByLevel, setDisableByLevel] = useState(false);
  const [disableByOptions, setDisableByOptions] = useState(false);
  const [disableAssetStatus, setDisableAssetStatus] = useState(false);

  const [statusValue, setStatusValue] = useState();
  const [riskValue, setRiskValue] = useState();
  const currentDate = utils.getCurrentDateFormatted("DD-MM-YYYY");
  const navigate = useNavigate();
  const [errors, setErrors] = useState({});
  // const [fromDate, setFromDate] = useState(null);
  // const [toDate, setToDate] = useState(null);
  const [gridApi, setGridApi] = useState(null);


  const handleNameClick = async (columnName, item) => {
    let updateLevel = level + 1;
    let additionalColumnDetails = item;
    // Set the new level and then make the API call 
    setLevel(updateLevel);
    setHistory([...history, data]);
    setCanGoBack(true);
    setLoading(true);
    if (updateLevel === 2) {
      setAssetOrderStatus(columnName);
    }

    // Update filterDetailsData with new parameters
    const updatedAssetDetailsData = {
      ...assetDetailsData,
      AssetOrderStatus: AssetOrderStatus,
      assetTypecodeid: additionalColumnDetails?.typeCodeId,
      locationid: additionalColumnDetails?.locationCodeId,
      assetId: additionalColumnDetails?.assetId,
      ageone: additionalColumnDetails?.ageone,
      agetwo: additionalColumnDetails?.agetwo,
      level: level + 1,
    };

    // Make the API call after setting the new level
    const getWorkOrderDetails = await fetchAssetDetails(
      updatedAssetDetailsData,
      columnName,
      updateLevel,
      additionalColumnDetails
    );
  };

  const handleLevelThreeClick = (newData) => {
    setLeveldata(newData);
  };

  const fetchAssetDetails = async (
    assetDetailsData,
    columnName,
    updateLevel,
    additionalColumnDetails
  ) => {
    let getWorkOrderDetails;
    let apiFilterData;
    if (columnName !== null) {
      apiFilterData = {
        hospitalId: assetDetailsData?.hospitalId,
        hospital: assetDetailsData?.hospital,
        groupBy: assetDetailsData?.groupBy,
        AssetType: updateLevel === 3 ? secondLevelRes?.service || assetDetailsData?.AssetType : assetDetailsData?.AssetType || "",
        // fromDate: assetDetailsData?.fromDate,
        // toDate: assetDetailsData?.toDate,
        status: assetDetailsData?.status,
        AssetStatus: assetDetailsData?.AssetStatus,
        AssetOrderStatus: updateLevel === 2 ? columnName : AssetOrderStatus,
        assetTypecodeid: additionalColumnDetails?.typeCodeId,
        locationid: additionalColumnDetails?.locationCodeId,
        groupById: assetDetailsData?.groupById,
        assetStatusId: assetDetailsData?.assetStatusId,
        assetId: assetDetailsData?.assetId,
        ageone: assetDetailsData?.ageone,
        agetwo: assetDetailsData?.agetwo,
      };

    } else {
      apiFilterData = {
        facilityid: assetDetailsData?.facilityid,
        hospital: assetDetailsData?.hospital,
        groupBy: assetDetailsData?.groupBy,
        AssetType: assetDetailsData?.AssetType,
        // fromDate: assetDetailsData?.fromDate,
        // toDate: assetDetailsData?.toDate,
        status: assetDetailsData?.status,
        AssetStatus: assetDetailsData?.AssetStatus,
      };
    }

    if (updateLevel === 3) {
      apiFilterData = {
        ...apiFilterData,
        facilityid: assetDetailsData?.hospitalId,
        assetId: additionalColumnDetails?.assetId,
        service: additionalColumnDetails?.service,
      };

      const AssetOrderStatus = "";
      setLastApiParams({ apiFilterData, AssetOrderStatus, updateLevel, additionalColumnDetails });  // Store the parameters of the last API call
    }
    if (updateLevel !== 3) {

      setLastApiParams({ apiFilterData, AssetOrderStatus, updateLevel, additionalColumnDetails }); // Store the parameters of the last API call
    }

    setHistoryApiFilterData(apiFilterData); // Store the apiFilterData of the last API call
    setLevel(updateLevel);
    getWorkOrderDetails = await AssetRepository.getAssetReport(
      apiFilterData,
      updateLevel
    );

    // Process the fetched details
    if (getWorkOrderDetails) {

      let apiFilter;
      setLoading(false);
      // Handling The Level Two Asset Report Data
      const handleLevelTwoData = (groupById) => {
        if (updateLevel === 2 && getWorkOrderDetails?.groupById === groupById) {
          apiFilter = getWorkOrderDetails?.assetAnalysisLevelTwo;
          setSecondLevelRes(getWorkOrderDetails?.assetAnalysisLevelTwo);
        }
      };

      if (updateLevel === 1) {
        if (assetDetailsData?.groupById === 1) {
          apiFilter = getWorkOrderDetails?.assetAnalysisTypeCodeList;
        }
        else if (assetDetailsData?.groupById === 2) {
          apiFilter = getWorkOrderDetails?.assetAnalysisLocationCodeList;
        }
        else if (assetDetailsData?.groupById === 3) {
          apiFilter = getWorkOrderDetails?.assetStatuses;
        }
        else if (assetDetailsData?.groupById === 4) {
          apiFilter = getWorkOrderDetails?.assetAges;
        }

      }
      else if (updateLevel === 2 && assetDetailsData.groupById == 11) {
        handleLevelThreeClick(getWorkOrderDetails);
      }
      else if (updateLevel === 2) {
        handleLevelTwoData(assetDetailsData.groupById);
      }
      else if (updateLevel === 3) {
        handleLevelThreeClick(getWorkOrderDetails);
      }

      if (apiFilter && updateLevel !== 3) {
        const updatedData = apiFilter?.map((item, index) => ({
          ...item,
          no: index + 1,
        }));
        if (updateLevel === 1) {
          setData(updatedData[0]);
        } else {
          setData(updatedData);
        }
      }
    }
  };
  useEffect(() => {
    const numericColumns = ["Size"]; // Add other numeric column names here
    const totalRow = {};
    workGroupCodeDetails();
    hospitalNameList();
    numericColumns.forEach((col) => {
      totalRow[col] = data?.reduce((sum, row) => sum + (row[col] || 0), 0);
    });
  }, []);


  const workGroupCodeDetails = async () => {
    try {
      const response = await AssetRepository.filterDetails();

      // Generic transformation function for common structures

      if (response.femassetanalysisgroupbies) {
        const groupData = response?.femassetanalysisgroupbies.filter(
          (item) => item.id >= 1 && item.id <= 4 || item.id == 11
        );

        const transformedData = groupData.map((item) => ({
          label: item.groupby,
          value: item.groupby,
          id: item.id,
        }));
        const groupDataForDetails = response?.femassetanalysisgroupbies.filter(
          (item) => item.id >= 1 && item.id <= 4
        );

        const transformedDataForDetails = groupDataForDetails.map((item) => ({
          label: item.groupby,
          value: item.groupby,
          id: item.id,
        }));

        setWorkGroupOptions(transformedData);
        setWorkGroupOptionsForDetails(transformedDataForDetails);

      }


      if (response.femassetstatuses) {
        const transformedDataAssetStatus = response?.femassetstatuses.map((item) => ({
          label: item.assetstatus,
          value: item.assetstatus,
          id: item.id,

        }));
        const transformedDataAssetStatusForDetails = transformedDataAssetStatus?.filter((item) => item?.label != "All")

        setAssetStatusOptions(transformedDataAssetStatus);
        setAssetStatusOptionsForDetails(transformedDataAssetStatusForDetails);

      }

      if (response.femassettypes) {
        const transAssetType = response?.femassettypes.map((item) => ({
          label: item.assettype,
          value: item.assettype,
          id: item.id,
        }));

        setassetTypeOptions(transAssetType);
      }

    } catch (error) {
      // console.error("Failed to fetch asset data:", error);
    }
  };

  // Hospital Drop down
  const hospitalNameList = async () => {
    try {
      const response = await AssetRepository.getHospitalName();

      if (response) {
        const hospitalList = response?.map((item) => ({
          value: item.facilityName,
          label: item.facilityName,
          id: item.facilityId,
        }));

        const allOption = { id: '00000000-0000-0000-0000-000000000000', label: 'All', value: 'All' };

        setHospitalOptions(hospitalList);

      }


    }
    catch (error) {
      // console.error("Failed to fetch asset data:", error);
    }
  };
  useEffect(() => {
    setLevelList(levelname?.find((item) => item.label == 'Hospital'))
    setOptionsList(optionsname?.find((item) => item.label == 'Summary'))

  }, []);

  useEffect(() => {
    if (assetServiceValue?.label == "BEMS" && optionslist?.label == "Details") {
      setRiskValue({ label: "All", value: "All" });
    }
    else {
      setRiskValue({ label: "", value: "" });
    }
  }, [optionslist?.label, assetServiceValue?.label, levellist?.label])

  useEffect(() => {
    setErrors({});
    const functions = async () => {


      if (levellist?.label == 'HQ' && optionslist?.label == 'Summary') {
        setDisableByLevel(true);
        let groupByValue = workGroupOptions?.find((item) => item?.id == 11);
        setGroupByValue(groupByValue);
        await handleOnChange("groupBy", groupByValue);
        let assetServiceValue = serviceTypeOptions?.find((item) => item?.label == 'All');
        setAssetServiceValue(assetServiceValue);
        await handleOnChange("AssetType", assetServiceValue);
        let statusValue = statusTypeOption?.find((item) => item?.label == 'All');
        setStatusValue(statusValue);
        await handleOnChange("status", statusValue);
        let assetStatusValue = AssetStatusOptions?.find((item) => item?.label == 'All');
        setAssetStatusValue(assetStatusValue);
        await handleOnChange("AssetStatus", assetStatusValue);
        setHospitalValue({});
        await new Promise((resolve) => setTimeout(resolve, 100));
      }
      else if (levellist?.label == 'HQ' && optionslist?.label == 'Details') {
        setHospitalValue(hospitalOptions?.find((item) => item?.label == 'All'));
        await handleOnChange("hospital", hospitalOptions?.find((item) => item?.label == "All"));
        setAssetStatusValue(AssetStatusOptions?.find((item) => item?.label == 'All'));
        await handleOnChange("AssetStatus", AssetStatusOptions?.find((item) => item?.label == "All"));

      }
      else if (levellist?.label == 'Hospital' && optionslist?.label == 'Summary') {
        setDisableByLevel(false);
        let groupByValue = workGroupOptions?.find((item) => item?.id == 11);
        setGroupByValue(groupByValue);
        await handleOnChange("groupBy", groupByValue);
        let assetServiceValue = serviceTypeOptions?.find((item) => item?.label == 'All');
        setAssetServiceValue(assetServiceValue);
        await handleOnChange("AssetType", assetServiceValue);
        let statusValue = statusTypeOption?.find((item) => item?.label == 'All');
        setStatusValue(statusValue);
        await handleOnChange("status", statusValue);
        let assetStatusValue = AssetStatusOptions?.find((item) => item?.label == 'All');
        setAssetStatusValue(assetStatusValue);
        await handleOnChange("AssetStatus", assetStatusValue);
        let hospitalValue = hospitalOptions?.find((item) => item?.label == localStorage.getItem('FacilityName'));
        setHospitalValue(hospitalValue);
        await handleOnChange("hospital", hospitalValue);
        await new Promise((resolve) => setTimeout(resolve, 100));
      }
      else if (levellist?.label == 'Hospital' && optionslist?.label == 'Details') {
        setDisableByLevel(false);
        let groupByValue = workGroupOptions?.find((item) => item?.id == 11);
        setGroupByValue(groupByValue);
        await handleOnChange("groupBy", groupByValue);
        let assetServiceValue = serviceTypeOptions?.find((item) => item?.label == 'All');
        setAssetServiceValue(assetServiceValue);
        await handleOnChange("AssetType", assetServiceValue);
        let statusValue = statusTypeOption?.find((item) => item?.label == 'All');
        setStatusValue(statusValue);
        await handleOnChange("status", statusValue);
        let assetStatusValue = AssetStatusOptions?.find((item) => item?.label == 'All');
        setAssetStatusValue(assetStatusValue);
        await handleOnChange("AssetStatus", assetStatusValue);
        let hospitalValue = hospitalOptions?.find((item) => item?.label == localStorage.getItem('FacilityName'));
        setHospitalValue(hospitalValue);
        await handleOnChange("hospital", hospitalValue);

        await new Promise((resolve) => setTimeout(resolve, 100));
      }
      else {

        setDisableByLevel(false);
      }
    };

    functions();
  }, [levellist, workGroupOptions]);
  useEffect(() => {
    setErrors({});
    const functions = async () => {
      if (levellist?.label == 'HQ' && optionslist?.label == 'Summary') {
        // setDisableByOptions(true);
        let groupByValue = workGroupOptions?.find((item) => item?.id == 11)
        setGroupByValue(groupByValue);
        await handleOnChange("groupBy", groupByValue);
        let assetServiceValue = serviceTypeOptions?.find((item) => item?.label == 'All')
        setAssetServiceValue(assetServiceValue);
        await handleOnChange("AssetType", assetServiceValue);
        let statusValue = statusTypeOption?.find((item) => item?.label == 'All')
        setStatusValue(statusValue)
        await handleOnChange("status", statusValue);
        let assetStatusValue = AssetStatusOptions?.find((item) => item?.label == 'All')
        setAssetStatusValue(assetStatusValue);
        await handleOnChange("AssetStatus", assetStatusValue);
        setHospitalValue({})
        setDisableByLevel(true);
      } else if (levellist?.label == 'Hospital' && optionslist?.label == 'Summary') {
        // setDisableByOptions(true);
        let groupByValue = workGroupOptions?.find((item) => item?.id == 11)
        setGroupByValue(groupByValue);
        await handleOnChange("groupBy", groupByValue);
        let assetServiceValue = serviceTypeOptions?.find((item) => item?.label == 'All')
        setAssetServiceValue(assetServiceValue);
        await handleOnChange("AssetType", assetServiceValue);
        let statusValue = statusTypeOption?.find((item) => item?.label == 'All')
        setStatusValue(statusValue)
        await handleOnChange("status", statusValue);
        let assetStatusValue = AssetStatusOptions?.find((item) => item?.label == 'All')
        setAssetStatusValue(assetStatusValue);
        await handleOnChange("AssetStatus", assetStatusValue);
        setHospitalValue({})
        setDisableAssetStatus(true);
        setHospitalValue(hospitalOptions?.find((item) => item?.label == localStorage.getItem('FacilityName')))
        await handleOnChange("hospital", hospitalOptions?.find((item) => item?.label == localStorage.getItem('FacilityName')));
        // setHospitalValue(hospitalOptions?.find((item) => item?.label == 'All'));
        // await handleOnChange("hospital", hospitalOptions?.find((item) => item?.label == "All"));
        // setDisableByLevel(true);
      }
      else if (optionslist?.label != 'Summary') {
        setDisableAssetStatus(false);
        setHospitalValue()
        setDisableByOptions(false);
        setDisableByLevel(false);
        setHospitalValue(hospitalOptions?.find((item) => item?.label == localStorage.getItem('FacilityName')))
        await handleOnChange("hospital", hospitalOptions?.find((item) => item?.label == localStorage.getItem('FacilityName')));

        //  setHospitalValue(hospitalOptions?.find((item) => item?.label == 'All'));
        //  await handleOnChange("hospital", hospitalOptions?.find((item) => item?.label == "All"));
        await new Promise((resolve) => setTimeout(resolve, 100)); // Allow React to render the loader before heavy work
      }
    }
    functions();
  }, [optionslist]);

  const handleGetResults = async () => {
    try {
      const newErrors = {};
      if (!levellist) newErrors.Level = "Please Select Level"
      if (!optionslist) newErrors.optionslist = "Please Select options"
      if (!assetServiceValue) newErrors.AssetType = "Please Select Asset Service"
      if (!statusValue) newErrors.status = "Please Select Status"
      if (levellist?.label != 'HQ' || (levellist?.label == 'HQ' && optionslist?.label == 'Details')) {
        if (!assetStatusValue) newErrors.AssetStatus = "Please Select Asset Status"
        if (!hospitalValue) newErrors.hospital = "Please Select Hospital"
      }

      if (Object.keys(newErrors)?.length > 0) {
        setErrors(newErrors);
      } else {
        setErrors({});
        setTableValues({ ...assetDetailsData });
        setcommonTableLabel(commonTableDetails);

        // Update Redux store
        dispatch(updateAssetDetails(assetDetailsData));
        let getWorkOrderDetails;

        let apiFilterData;
        const getcolumnName = null;
        const getupdateLevel = 1;
        apiFilterData = {
          facilityid: assetDetailsData?.facilityid,
          hospital: assetDetailsData?.hospital,
          groupBy: 0,
          AssetType: assetDetailsData?.AssetType,
          // fromDate: assetDetailsData?.fromDate,
          // toDate: assetDetailsData?.toDate,
          status: assetDetailsData?.status,
          AssetStatus: assetDetailsData?.AssetStatus,
          token: token,
          userId: userId,
          companyId: companyId,

        };

        if (level === 2) {
          apiFilterData = {
            hospitalId: assetDetailsData?.hospitalId,
            hospital: assetDetailsData?.hospital,
            groupBy: assetDetailsData?.groupBy,
            AssetType: assetDetailsData?.AssetType,
            // fromDate: assetDetailsData?.fromDate,
            // toDate: assetDetailsData?.toDate,
            status: assetDetailsData?.status,
            AssetStatus: assetDetailsData?.AssetStatus,
            AssetOrderStatus: AssetOrderStatus,
            assetTypecodeid: typeCodeIdClick,
            locationid: locationIdClick,
            groupById: assetDetailsData?.groupById,
            assetStatusId: assetDetailsData?.assetStatusId,
            token: token,
            userId: userId,
            companyId: companyId,
          };
        }

        setLastApiParams({
          apiFilterData,
          columnName: getcolumnName,
          updateLevel: getupdateLevel,
        }); // Store the parameters of the last API call
        const payload = (levellist?.label == 'HQ' && optionslist?.label == 'Summary') ?
          assetStatusValue?.label == "All" ? {
            ...assetDetailsData, hospitalId: null, assetStatusId: null, groupById: 0, token: token, userId: userId, companyId: companyId, Level: 1, Service: assetServiceValue?.label == "BEMS" ? 1 : null,
            authorized: statusValue?.label == "All" ? null : statusValue?.label == "Active" ? true : false, Risklevelbems: riskValue?.label || ""
          }
            :
            {
              ...assetDetailsData, hospitalId: null, groupById: 0, token: token, userId: userId, companyId: companyId, Level: 1, Service: assetServiceValue?.label == "BEMS" ? 1 : null,
              authorized: statusValue?.label == "All" ? null : statusValue?.label == "Active" ? true : false, Risklevelbems: riskValue?.label || ""
            }
          :
          (levellist?.label == 'Hospital' && optionslist?.label == 'Summary')
            ?
            assetStatusValue?.label == "All" ? {
              ...assetDetailsData, assetStatusId: null, token: token, userId: userId, companyId: companyId, groupById: groupByValue?.label == "All" ? 0 : groupByValue?.id, hospitalId: hospitalValue?.id
              , authorized: statusValue?.label == "All" ? null : statusValue?.label == "Active" ? true : false, Level: 1, Service: assetServiceValue?.label == "BEMS" ? 1 : null, Risklevelbems: riskValue?.label || ""
            }
              :
              { ...assetDetailsData, token: token, userId: userId, companyId: companyId, authorized: statusValue?.label == "All" ? null : statusValue?.label == "Active" ? true : false, assetStatusId: assetStatusValue?.id, groupById: 0, token: token, userId: userId, companyId: companyId, hospitalId: hospitalValue?.id, Level: 1, service: assetServiceValue?.label == "BEMS" ? 1 : null, Risklevelbems: riskValue?.label || "" }
            :
            assetStatusValue?.label == "All" ? { ...assetDetailsData, assetStatusId: null, groupById: groupByValue?.id, authorized: statusValue?.label == "All" ? null : statusValue?.label == "Active" ? true : false, Service: assetServiceValue?.label == "BEMS" ? 1 : null, Level: 0, token: token, userId: userId, companyId: companyId, Risklevelbems: riskValue?.label || "" }
              :
              { ...assetDetailsData, token: token, userId: userId, companyId: companyId, assetStatusId: assetStatusValue?.id, groupById: groupByValue?.id, authorized: statusValue?.label == "All" ? null : statusValue?.label == "Active" ? true : false, Service: assetServiceValue?.label == "BEMS" ? 1 : null, Level: 0, token: token, userId: userId, companyId: companyId, Risklevelbems: riskValue?.label || "" };
        setLoadingPage(true);
        await new Promise((resolve) => setTimeout(resolve, 0)); // Allow React to render the loader before heavy work
        getWorkOrderDetails = (levellist?.label == 'Hospital' && optionslist?.label == 'Details') ?
          await AssetRepository.getAssetReport(payload, 1)
          :
          (levellist?.label == 'Hospital' && optionslist?.label == 'Summary') ?
            await AssetRepository.getAssetReport(
              payload,
              "Summary"
            )
            :
            (levellist?.label == 'HQ' && optionslist?.label == 'Summary') ?
              await AssetRepository.getAssetReport(
                payload,
                "Summary"
              )
              :
              await AssetRepository.getAssetReport(
                payload,
                1
              );
        if (getWorkOrderDetails) {
          let apiFilter = [];
          if (optionslist?.label == 'Summary') {
            let i;
            for (i = 0; i < getWorkOrderDetails?.assetAnalysisTypeCodeList?.length; i++) {
              apiFilter.push(getWorkOrderDetails?.assetAnalysisTypeCodeList[i]);
            }
          } else if (assetDetailsData?.groupById === 1) {
            // let i;
            // for (i = 0; i < getWorkOrderDetails?.assetAnalysisTypeCodeList.length; i++) {
            //   apiFilter.push(getWorkOrderDetails?.assetAnalysisTypeCodeList[i]);
            // }
            let i;
            for (i = 0; i < getWorkOrderDetails?.assetAnalysisTypeCodeList.length; i++) {
              const { id, facilityId, assetStatusId, bemsAssetCount, femsAssetCount, totalCount, ...rest } = getWorkOrderDetails?.assetAnalysisTypeCodeList[i];
              apiFilter.push(rest);
            }
          } else if (assetDetailsData?.groupById === 2) {
            let i;
            for (i = 0; i < getWorkOrderDetails?.assetAnalysisLocationCodeList.length; i++) {
              apiFilter.push(getWorkOrderDetails?.assetAnalysisLocationCodeList[i]);
            }
          }
          else if (assetDetailsData?.groupById === 3) {
            let i;
            for (i = 0; i < getWorkOrderDetails?.assetStatuses.length; i++) {
              apiFilter.push(getWorkOrderDetails?.assetStatuses[i]);
            }
          }
          else if (assetDetailsData?.groupById === 4) {
            let i;
            for (i = 0; i < getWorkOrderDetails?.assetAges.length; i++) {
              apiFilter.push(getWorkOrderDetails?.assetAges[i]);
            }
          }
          else if (groupByValue?.id === 11) {
            let i;
            for (i = 0; i < getWorkOrderDetails?.assetAnalysisLevelTwo?.length; i++) {
              apiFilter.push(getWorkOrderDetails?.assetAnalysisLevelTwo[i]);
            }
          }
          if (apiFilter && apiFilter.length > 0) {
            // Filter out undefined values
            const filteredApiFilter = apiFilter.filter(
              (item) => item !== undefined
            );

            // Proceed only if there are valid items
            if (filteredApiFilter.length > 0) {
              const updatedData = filteredApiFilter.map((item, index) => ({
                ...item,
                no: index + 1,
              }));
              if ((levellist?.label == 'HQ' || levellist?.label == 'Hospital') && optionslist?.label == 'Summary') {
                setLevel(7);
              } else {
                setLevel(1);
                if (groupByValue?.id == 11) {
                  setLevel(2);
                }
              }
              setData(updatedData);

            } else {
              // Handle case where filtered array is empty
              setData([]);
              if ((levellist?.label == 'HQ' || levellist?.label == 'Hospital') && optionslist?.label == 'Summary') {
                setLevel(7);
              } else {
                setLevel(1);
              }
            }
          } else {
            // Handle case where apiFilter is empty or undefined
            setData([]);
            setLevel(1);
          }
        }
      }
    } catch (e) {
      // console.error(e);
    }
    finally {
      setLoadingPage(false);
      await new Promise((resolve) => setTimeout(resolve, 0)); // Allow React to render the loader before heavy work

    }
  };


  const handleBackClick = () => {
    if (level > 1) {
      setData(history[history.length - 1]);
      setHistory(history.slice(0, -1));
      setLevel(level - 1);
      setCanGoBack(level > 2);
      let apiFilterData = historyApiFilterData;
      setLastApiParams({
        apiFilterData,
        columnName: AssetOrderStatus,
        updateLevel: level - 1,
      }); // Store the parameters of the last API call
    }
  };
  let commonTableDetails = {
    hospital: assetDetailsData?.hospital ? assetDetailsData?.hospital : null,
    groupBy: assetDetailsData?.groupBy ? assetDetailsData?.groupBy : null,
    // fromDate: assetDetailsData?.fromDate ? assetDetailsData?.fromDate : null,
    // toDate: assetDetailsData?.toDate ? assetDetailsData?.toDate : null,
    status: assetDetailsData?.status ? assetDetailsData?.status : null,
    AssetStatus: assetDetailsData?.AssetStatus ? assetDetailsData?.AssetStatus : null,
  };




  return (
    <>
      <PageLoader open={loadingPage} />
      <Box mt={{ xs: 1, sm: 2 }}>
        <PageTitle title="Asset Analysis Report" />
        <DefaultCard>
          <Grid container spacing={2}>
            <Grid item xs={12} md={12}>
              <Typography variant="h5">Filter Details</Typography>
            </Grid>
            <Grid item xs={6} md={4}>
              <CustomSelectInput
                label="Level"
                value={levellist}
                options={levelname}
                onChange={(e) => {
                  handleOnChange("Level", (e));
                  setLevelList(e);
                  if (e?.label == 'HQ') {
                    setAssetStatusValue();
                    setHospitalValue();
                  }
                }}
                disabled={level !== 1 || !access?.canEdit} // Disable if level is not 1
                errorMessage={errors.Level}
                error={!!errors.Level}
                isMandatoryField={true}
              //  defaultOption={levelname?.find((item)=>item.label=='HQ')}
              />
            </Grid>
            <Grid item xs={6} md={4}>
              <CustomSelectInput
                label="Options"
                value={optionslist}
                disabled={level !== 1}
                options={optionsname}
                isMandatoryField={true}
                // defaultOption={optionsname[0]}
                errorMessage={errors.optionslist}
                error={!!errors.optionslist}
                onChange={(e) => {
                  if (e != null) {
                    setOptionsList(e);
                    setErrors({ ...errors, optionslist: '' })
                  } else {
                    setOptionsList('');
                  }

                }}
              />
            </Grid>
            <Grid item xs={6} md={4}>
              <CustomSelectInput
                label="Hospital"
                isMandatoryField={!disableByLevel}
                value={hospitalValue}
                options={
                  levellist?.label === 'HQ'
                    ? [{ label: "All", value: "all", id: '00000000-0000-0000-0000-000000000000' }, ...(hospitalOptions ?? [])] // Ensure "All" is added
                    : (Array.isArray(hospitalOptions) ? hospitalOptions.filter((h) => h.label !== 'All') : [])
                }
                onChange={(e) => {
                  handleOnChange("hospital", e);
                  setHospitalValue(e);
                }}
                errorMessage={errors.hospital}
                error={!!errors.hospital}
                disabled={level !== 1 || disableByLevel || !access?.canEdit}
              />



            </Grid>

            <Grid item xs={6} md={4}>
              <CustomSelectInput
                id="GroupBy"
                label="Group By"
                // isMandatoryField={true}
                value={groupByValue}
                // autoFocus={true}
                // options={optionslist?.label == 'Summary' ? workGroupOptions : workGroupOptions}
                options={workGroupOptions?.sort((a, b) => {
                  return a.label.localeCompare(b.label);
                })}
                errorMessage={errors.groupBy}
                error={!!errors.groupBy}
                onChange={(newValue) => {
                  handleOnChange("groupBy", newValue);
                  setGroupByValue(newValue);
                }}
                disabled={level !== 1 || disableByOptions}
              />
            </Grid>

            <Grid item xs={6} md={4}>
              <CustomSelectInput
                id="AssetType"
                label="Asset Service"
                isMandatoryField={true}
                value={assetServiceValue}
                // options={optionslist?.label == 'Summary' ? serviceTypeOptions : serviceTypeOptions}
                options={serviceTypeOptions?.sort((a, b) => {
                  return a.label.localeCompare(b.label);
                })}
                errorMessage={errors.AssetType}
                error={!!errors.AssetType}
                onChange={(newValue) => {
                  handleOnChange("AssetType", newValue);
                  setAssetServiceValue(newValue);
                }}
                disabled={level !== 1 || disableByOptions}
              />
            </Grid>


            {/* <Grid item xs={6} md={4}>
              <CustomDatePicker
                label="From Date"
                name="fromDate"
                error={!!errors.fromDate}
                isStartDate={true}
                disablePastDate={true}
                id={"from-date"}
                maxDate={currentDate}
                errorMessage={errors.fromDate}
                // isMandatoryField={true}
                value={fromDate}
                onDateChange={(newValue) => {
                  setFromDate(newValue);
                  handleOnChange("fromDate", newValue);
                }}
                disabled={level !== 1}
              />
            </Grid>

            <Grid item xs={6} md={4}>
              <CustomDatePicker
                name="toDate"
                label="To Date"
                isStartDate={true}
                disablePastDate={true}
                id={"to-date"}
                maxDate={currentDate}
                // isMandatoryField={true}
                value={toDate}
                errorMessage={errors.toDate}
                error={!!errors.toDate}
                onDateChange={(newValue) => {
                  handleOnChange("toDate", newValue);
                }}
                disabled={level !== 1}
              />
            </Grid> */}

            <Grid item xs={6} md={4}>
              <CustomSelectInput
                id="status"
                label="Status"
                isMandatoryField={true}
                value={statusValue}
                // options={optionslist?.label == 'Summary' ? statusTypeOption : statusTypeOption}
                options={statusTypeOption?.sort((a, b) => {
                  if (a.label === "All") return -1; // `a` comes first if it matches `specialLabel`
                  if (b.label === "All") return 1;  // `b` comes first if it matches `specialLabel`
                  return a.label.localeCompare(b.label);   // Sort alphabetically for the rest
                })
                }
                errorMessage={errors.status}
                error={!!errors.status}
                onChange={(newValue) => {
                  handleOnChange("status", newValue);
                  setStatusValue(newValue);
                }}
                disabled={level !== 1 || disableByOptions}
              />
            </Grid>
            <Grid item xs={6} md={4}>
              <CustomSelectInput
                id="Asset Status"
                name="AssetStatus"
                label="Asset Status"
                isMandatoryField={!disableByLevel}
                value={assetStatusValue}
                errorMessage={errors.AssetStatus}
                error={!!errors.AssetStatus}
                // options={optionslist?.label == 'Summary' ? AssetStatusOptions : AssetStatusOptions}
                options={AssetStatusOptions?.sort((a, b) => {
                  return a.label.localeCompare(b.label);
                })}

                onChange={(newValue) => {
                  handleOnChange("AssetStatus", newValue);
                  setAssetStatusValue(newValue);
                }}
                disabled={level !== 1}
              />
            </Grid>
            {(optionslist?.label == 'Details' && assetServiceValue?.label == "BEMS") && (
              <Grid item xs={6} md={4}>
                <CustomSelectInput
                  id="risk"
                  label="Risk Level"
                  isMandatoryField={true}
                  value={riskValue}
                  // options={optionslist?.label == 'Summary' ? statusTypeOption : statusTypeOption}
                  options={riskTypeOption?.sort((a, b) => {
                    if (a.label === "All") return -1; // `a` comes first if it matches `specialLabel`
                    if (b.label === "All") return 1;  // `b` comes first if it matches `specialLabel`
                    return a.label.localeCompare(b.label);   // Sort alphabetically for the rest
                  })
                  }
                  errorMessage={errors.status}
                  error={!!errors.status}
                  onChange={(newValue) => {
                    handleOnChange("risk", newValue);
                    setRiskValue(newValue);
                  }}
                  disabled={level !== 1 || disableByOptions}
                  disableClearable={true}
                />
              </Grid>
            )}

          </Grid>

          <Grid item xs={6} md={2}>
            <Box
              sx={{
                marginTop: "20px",
                display: "flex",
                gap: 2,
                justifyContent: { xs: "center", md: "end" },
              }}
            >
              <Button variant="contained" onClick={handleGetResults}  >
                GET RESULT
              </Button>

              <Button sx={{ border: "1px solid" }} onClick={() => window.location.reload()}  >
                REFRESH
              </Button>
            </Box>
          </Grid>

        </DefaultCard>
      </Box>

      <div className="button-container">
        <Stack direction={"row"} alignItems={"flex-end"}>
          <Tooltip
            title="back"
            placement="bottom"
            arrow
            disableFocusListener
            disableInteractive
          >
            <IconButton onClick={handleBackClick} disabled={!canGoBack}>
              <ArrowBackRoundedIcon />
            </IconButton>
          </Tooltip>
        </Stack>

        <RefreshAssetButtons
          data={allRows}
          headerValues={{
            hospital: hospitalValue?.label != undefined ? hospitalValue?.label : "All", groupby: groupByValue?.label, assetstatus: assetStatusValue?.label
          }}
          sheetname="asset"
          // filename={workOrderTitle}
          filename="ASSET ANALYSIS, LISTING AND SUMMARY HISTORY"
          refData={data ? data : []}
          reportLevel={level}
          commonTableDetails={commonTableDetails}
          enablePdfButton={optionslist?.label == "Details" ? false : true}
          enableprintButton={optionslist?.label == "Details" ? false : true}
        />
      </div>

      <DefaultCard mt={{ xs: 1, sm: 2 }}>
        <div id="printableAreas">
          <div className="grid-header">
            <div className="logo-container">
              <p className="title-text">ASSET ANALYSIS, LISTING AND SUMMARY HISTORY </p>
              <img src={reportslogo} alt="logo3" className="logo3" />
            </div>
          </div>

          {/* <table className="table-container">
            <thead>
              <tr>
                <th>Hospital</th>
                <td> {assetDetailsData?.hospital
                  ? assetDetailsData?.hospital
                  : null}</td>
                <th>Group By</th>
                <td>
                  {assetDetailsData?.groupBy
                    ? assetDetailsData?.groupBy
                    : null}
                </td>
                <th>Asset Status</th>
                <td>
                  {assetDetailsData?.AssetStatus
                    ? assetDetailsData?.AssetStatus
                    : null}
                </td>

              </tr>
              <tr>
                <th>From Date</th>
                <td>
                  {assetDetailsData?.fromDate
                    ? assetDetailsData?.fromDate
                    : null}
                </td>
                <th>To Date</th>
                <td colSpan={5}>
                  {assetDetailsData?.toDate ? assetDetailsData?.toDate : null}
                </td>
              </tr>
            </thead>
          </table>
        </div> */}
          <table className="table-container">
            <thead>
              <tr>
                <th>Hospital</th>
                <td>{hospitalValue?.label != undefined ? hospitalValue?.label : "All"}</td>
                <th>Group By</th>
                <td>
                  {groupByValue?.label}
                </td>
                <th>Asset Status</th>
                <td>
                  {assetStatusValue?.label}
                </td>
                {/* <th>From Date</th>
                <td colSpan="3">
                  {commonTableLabel?.fromDate|| ""}
                </td> */}
              </tr>
              {/* <tr>
                <th>To Date</th>
                <td colSpan={7}>
                  {commonTableLabel?.toDate || ""}
                  {/* {matchingWoType ? matchingWoType.label : ""} */}
              {/* </td> */}
              {/* </tr>  */}
            </thead>
          </table>
        </div>
        <Box mt={{ xs: 1, sm: 2 }}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              {loading ? (
                <Box display="flex" justifyContent="center" alignItems="center">
                  <CircularProgress />
                  <h4>Loading ...</h4>
                </Box>
              ) : level == 7 && optionslist?.label == 'Summary' && data && data.length > 0 ? (
                <CustomAgGrid
                  ref={gridRef}
                  setGridApi={setGridApi}
                  rows={data}
                  columns={columnsForSummary}
                  isEnableView={false}
                  disableFilter={true}
                  pageName={"Reports"}
                />
              ) : ((level === 3 && leveldata) || ((level === 2 && leveldata.length > 0 && groupByValue?.id == 11))) ? (
                <AssetFinalreport
                  finalReportDetails={leveldata}
                  AssetType={
                    assetDetailsData?.AssetType
                      ? assetDetailsData.AssetType
                      : 0
                  }
                />
              ) : level !== 3 && data && data.length > 0 ? (
                <CustomAgGrid
                  ref={gridRef}
                  setGridApi={setGridApi}
                  rows={data}
                  columns={columns}
                  isEnableView={false}
                  // disableFilter={true}
                  pageName={"Reports"}
                />
              ) : (
                <Typography variant="h6" align="center">
                  No records found
                </Typography>
              )}
            </Grid>
          </Grid>
        </Box>

      </DefaultCard>
    </>
  );
};

export default AssetAnalysisreport;
